'use client';

import * as React from 'react';
import {
  showLikeAtom,
  showTocAtom,
} from 'app/blog/[domain]/_components/design-state';
import { useAtomValue } from 'jotai';
import { AsideActions, type AsideActionProps } from './aside-actions';
import { TOC as Toc, type TocProps } from './toc/toc';

export type PostAsideProps = {
  postId: string;
  showComment?: boolean;
} & Omit<AsideActionProps, 'showLike'> &
  TocProps;

export function PostAside({
  toc,
  showComment,
  domain,
  commentCount,
  likeCount,
  postId,
}: PostAsideProps): JSX.Element {
  const { showAside, showLike, showToc } = useShowAside({ toc, showComment });
  if (!showAside) {
    return <></>;
  }
  const renderToc = showToc && toc.length > 0;
  const actions = (
    <>
      {(showComment || showLike) && (
        <AsideActions
          showComment={showComment}
          showLike={showLike}
          domain={domain}
          commentCount={commentCount}
          postId={postId}
          likeCount={likeCount}
        />
      )}
    </>
  );
  return (
    <aside className="post-aside">
      {renderToc ? <Toc toc={toc}>{actions}</Toc> : actions}
    </aside>
  );
}

export type ShowAsideProps = {
  toc: TocProps['toc'];
  showComment: boolean;
};

export function useShowAside({ toc, showComment }: ShowAsideProps) {
  const showToc = useAtomValue(showTocAtom);
  const showLike = useAtomValue(showLikeAtom);
  const showAside = (showToc && toc.length > 0) || showComment || showLike;
  return {
    showAside,
    showLike,
    showToc,
  };
}
